import React, { useEffect, useState } from "react";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import axiosInstance from "../axiosConfig";
import "../styles/loader.css";
import Loader from "../components/Loader";
import { set } from "react-hook-form";

const ServicesPricing = () => {
  const [activeButton, setActiveButton] = useState("btn1");
  const [categories, setCategories] = useState([]);
  const [packages, setPackages] = useState([]);
  const [services, setServices] = useState([]);
  const [variations, setVariations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeCategory, setActiveCategory] = useState("");

  // const handleButtonClick = buttonId => {
  //   setActiveButton(buttonId);
  // };
  useEffect(
    () => {
      const fetchCategories = async () => {
        try {
          const gender = activeButton === "btn1" ? "male" : "female";
          setLoading(true);
          const response = await axiosInstance.get(
            `/service-categories?gender=${gender}`
          );
          if (response.data.success) {
            setCategories(response.data.categories);
            setPackages(response.data.packages);
            if (response.data.categories.length > 0) {
              setActiveCategory(response.data.categories[0].id);
            }
          } else {
            setError(response.data.error || "Error fetching categories");
          }
        } catch (error) {
          setError("An error occurred while fetching the categories");
        } finally {
          setLoading(false);
        }
      };

      if (activeButton) {
        fetchCategories();
      }
    },
    [activeButton]
  );

  useEffect(
    () => {
      const fetchServices = async () => {
        if (!activeCategory) return;

        try {
          const gender = activeButton === "btn1" ? "male" : "female";
          setLoading(true);
          const response = await axiosInstance(
            `/service-details?gender=${gender}&category=${activeCategory}`
          );
          if (response.data.success) {
            setServices(response.data.services);
            setVariations(response.data.variations);
          } else {
            setError(response.data.error || "Error fetching services");
          }
        } catch (error) {
          setError("An error occurred while fetching the services");
        } finally {
          setLoading(false);
        }
      };

      fetchServices();
    },
    [activeCategory, activeButton]
  );

  const handleButtonClick = buttonId => {
    setActiveButton(buttonId);
    setActiveCategory("");
    setServices([]);
  };

  const handleCategoryClick = categoryId => {
    setActiveCategory(categoryId);
  };

  if(loading){
    return <Loader />;
  }

  return (
    <section className="services-tab services-pricing pt-4">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-12">
            <div className="services-btn-tab">
              <button
                id="btn1"
                className={`services-btn ${activeButton === "btn1"
                  ? "active"
                  : ""}`}
                onClick={() => handleButtonClick("btn1")}
              >
                <img src="assets/images/male-face-icon.png" alt="Male" />Male
              </button>
              <button
                id="btn2"
                className={`services-btn ${activeButton === "btn2"
                  ? "active"
                  : ""}`}
                onClick={() => handleButtonClick("btn2")}
              >
                <img
                  src="assets/images/woman-face-icon.png"
                  alt="Female"
                />Female
              </button>
            </div>
            <div
              id="div1"
              style={{ display: activeButton === "btn1" ? "block" : "none" }}
            >
              <div className="row justify-content-center">
                <div className="col-lg-4">
                  <div className="services-tab-box">
                    <ul className="nav flex-column nav-pills">
                      {categories.map(category =>
                        <li className="nav-item" key={category.id}>
                          <button
                            className={`nav-link ${activeCategory ===
                            category.id
                              ? "active"
                              : ""}`}
                            onClick={() => handleCategoryClick(category.id)}
                          >
                            {category.name}
                          </button>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
                <div className="col-lg-8">
                  {activeCategory &&
                    <div className="tab-content">
                      {services.map(category =>
                        <div
                          className="tab-pane fade show active"
                          id={category.name.replace(/\s+/g, "")}
                          key={category.id}
                        >
                          <div className="services-name-list">
                            {Array.isArray(category.services) &&
                              category.services.length > 0 &&
                              <div>
                                <ul>
                                  {Array.isArray(category.services) &&
                                    category.services.map((service, index) =>
                                      <li key={index}>
                                        <div className="services-name">
                                          <div>
                                            {service.name}
                                            {service.footnote &&
                                              service.footnote.trim() !== "" &&
                                              <span>
                                                ({service.footnote})
                                              </span>}
                                          </div>
                                        </div>
                                        <div className="services-price">
                                          <div className="form-check">
                                            <label
                                              className="form-check-label"
                                              for={`flexCheckDefault${index}`}
                                            >
                                              ₹{service.price}
                                            </label>
                                          </div>
                                        </div>
                                      </li>
                                    )}
                                </ul>
                              </div>}
                            {Array.isArray(category.subcategories) &&
                              category.subcategories.length > 0 &&
                              <div>
                                {category.subcategories.map(
                                  (subcategory, subcategoryIndex) =>
                                    <div key={subcategoryIndex}>
                                      <h3>
                                        {subcategory.name}
                                      </h3>
                                      {Array.isArray(subcategory.services) &&
                                        subcategory.services.length > 0 &&
                                        <ul>
                                          {subcategory.services.map(
                                            (service, serviceIndex) =>
                                              <li key={serviceIndex}>
                                                <div className="services-name">
                                                  <div>
                                                    {service.name}
                                                    {service.footnote &&
                                                      service.footnote.trim() !==
                                                        "" &&
                                                      <span>
                                                        ({service.footnote})
                                                      </span>}
                                                  </div>
                                                </div>
                                                <div className="services-price">
                                                  <div className="form-check">
                                                    <label
                                                      className="form-check-label"
                                                      for={`flexCheckDefault${serviceIndex}`}
                                                    >
                                                      ₹{service.price}
                                                    </label>
                                                  </div>
                                                </div>
                                              </li>
                                          )}
                                        </ul>}
                                    </div>
                                )}
                              </div>}
                          </div>
                        </div>
                      )}
                    </div>}
                </div>
              </div>
              <div className="row justify-content-center">
                {packages.map((pkg, index) =>
                  <div className="col-sm-10 col-md-6 col-lg-4 text-center">
                    <div className="price-main">
                      <div className="price-text">
                        <h3>
                          {pkg.name}
                        </h3>
                        <div className="round-shape" />
                        <h2>
                          ₹{pkg.price}
                        </h2>
                      </div>
                      <div className="price-bottom">
                        <ul>
                          {pkg.services
                            ? pkg.services.split(",").map((
                                service,
                                index // Split
                              ) =>
                                <li key={index}>
                                  <span>{service.trim()}</span>{" "}
                                </li>
                              )
                            : null}
                        </ul>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div
              id="div2"
              style={{ display: activeButton === "btn2" ? "block" : "none" }}
            >
              <div className="row justify-content-center">
                <div className="col-lg-4">
                  <div className="services-tab-box">
                    <ul className="nav flex-column nav-pills">
                      <li className="nav-item">
                        <button
                          className={`nav-link ${activeCategory === null ? 'active' : ''}`}
                          onClick={() => handleCategoryClick(null)}
                        >
                          <span>Hair Size</span>
                        </button>
                      </li>
                      {categories.map(category =>
                        <li className="nav-item" key={category.id}>
                          <button
                            className={`nav-link ${activeCategory ===
                            category.id
                              ? "active"
                              : ""}`}
                            onClick={() => handleCategoryClick(category.id)}
                          >
                            {category.name}
                          </button>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
                <div className="col-lg-8">
                  {activeCategory === null && (
                    <div className="tab-content">
                          <div className='tab-pane fade show active' id="hair-size-tab" role='tabpanel' aria-labelledby='hair-size-tab'>
                            <div className="row justify-content-center">
                              <div className="col-sm-6 col-md-4 col-lg-4">
                                <div className="hair-style">
                                  <img
                                    src="assets/images/pixie.png"
                                    alt="pixie"
                                    className="img-fluid"
                                  />
                                  <div className="hair-style-content">
                                    <div className="hair-style-name">
                                      <span>pixie</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-6 col-md-4 col-lg-4">
                                <div className="hair-style">
                                  <img
                                    src="assets/images/bob.png"
                                    alt="bob"
                                    className="img-fluid"
                                  />
                                  <div className="hair-style-content">
                                    <div className="hair-style-name">
                                      <span>bob</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-6 col-md-4 col-lg-4">
                                <div className="hair-style">
                                  <img
                                    src="assets/images/short.png"
                                    alt="short"
                                    className="img-fluid"
                                  />
                                  <div className="hair-style-content">
                                    <div className="hair-style-name">
                                      <span>short</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-6 col-md-4 col-lg-4">
                                <div className="hair-style">
                                  <img
                                    src="assets/images/medium.png"
                                    alt="medium"
                                    className="img-fluid"
                                  />
                                  <div className="hair-style-content">
                                    <div className="hair-style-name">
                                      <span>medium</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-6 col-md-4 col-lg-4">
                                <div className="hair-style">
                                  <img
                                    src="assets/images/long.png"
                                    alt="long"
                                    className="img-fluid"
                                  />
                                  <div className="hair-style-content">
                                    <div className="hair-style-name">
                                      <span>long</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                    </div>
                  )}
                  {activeCategory &&
                    <div className="tab-content">
                      {services.map(category =>
                        <div
                          className="tab-pane fade show active"
                          id={category.name.replace(/\s+/g, "")}
                          key={category.id}
                        >
                          <div className="cat-package">
                            {Array.isArray(variations) &&
                              variations.length > 0 &&
                              variations.map((variation, index) =>
                                <div key={index}>
                                  <div className="cat-package-title">
                                    {variation.name}
                                  </div>
                                </div>
                              )}
                          </div>
                          <div className="services-name-list">
                            {Array.isArray(category.services) &&
                              category.services.length > 0 &&
                              <div>
                                <ul>
                                  {Array.isArray(category.services) &&
                                    category.services.map((service, index) =>
                                      <li key={index}>
                                        <div className="services-name">
                                          <div>
                                            {service.name}
                                            {service.footnote &&
                                              service.footnote.trim() !== "" &&
                                              <span>
                                                ({service.footnote})
                                              </span>}
                                          </div>
                                        </div>
                                        <div className="services-price">
                                          {(!Array.isArray(
                                            service.service_variationsnew
                                          ) ||
                                            service.service_variationsnew
                                              .length === 0) &&
                                            <div className="form-check">
                                              <label
                                                className="form-check-label"
                                                for={`flexCheckDefault${index}`}
                                              >
                                                ₹{service.price}
                                              </label>
                                            </div>}
                                        </div>
                                        {Array.isArray(
                                          service.service_variationsnew
                                        ) &&
                                          service.service_variationsnew.length >
                                            0 &&
                                          <div className="services-price waxing">
                                            {service.service_variationsnew.map(
                                              (variation, variationIndex) =>
                                                <div
                                                  key={variationIndex}
                                                  className="form-check"
                                                >
                                                  <label
                                                    className="form-check-label"
                                                    htmlFor={`flexCheckDefaultVariation${variationIndex}`}
                                                  >
                                                    ₹{variation.variation_price}
                                                  </label>
                                                </div>
                                            )}
                                          </div>}
                                      </li>
                                    )}
                                </ul>
                              </div>}
                            {Array.isArray(category.subcategories) &&
                              category.subcategories.length > 0 &&
                              <div>
                                {category.subcategories.map(
                                  (subcategory, subcategoryIndex) =>
                                    <div key={subcategoryIndex}>
                                      <h3>
                                        {subcategory.name}
                                      </h3>
                                      {Array.isArray(subcategory.services) &&
                                        subcategory.services.length > 0 &&
                                        <ul>
                                          {subcategory.services.map(
                                            (service, serviceIndex) =>
                                              <li key={serviceIndex}>
                                                <div className="services-name">
                                                  <div>
                                                    {service.name}
                                                    {service.footnote &&
                                                      service.footnote.trim() !==
                                                        "" &&
                                                      <span>
                                                        ({service.footnote})
                                                      </span>}
                                                  </div>
                                                </div>
                                                <div className="services-price">
                                                  <div className="form-check">
                                                    <label
                                                      className="form-check-label"
                                                      for={`flexCheckDefault${serviceIndex}`}
                                                    >
                                                      ₹{service.price}
                                                    </label>
                                                  </div>
                                                </div>
                                              </li>
                                          )}
                                        </ul>}
                                    </div>
                                )}
                              </div>}
                          </div>
                        </div>
                      )}
                    </div>}
                </div>
              </div>
              <div className="row justify-content-center">
                {packages.map((pkg, index) =>
                  <div className="col-sm-10 col-md-6 col-lg-4 text-center">
                    <div className="price-main">
                      <div className="price-text">
                        <h3>
                          {pkg.name}
                        </h3>
                        <div className="round-shape" />
                        <h2>
                          ₹{pkg.price}
                        </h2>
                      </div>
                      <div className="price-bottom">
                        <ul>
                          {pkg.services
                            ? pkg.services.split(",").map((
                                service,
                                index // Split
                              ) =>
                                <li key={index}>
                                  <span>{service.trim()}</span>{" "}
                                </li>
                              )
                            : null}
                        </ul>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesPricing;
